
    /*!
    * Copyright (c) Microsoft Corporation.
    * All rights reserved. See LICENSE in the project root for license information.
    * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
    * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
    */
    import {
        AsyncResult,
        callActionOrExecute,
        DataServiceQuery,
        IContext,
        IDataServiceRequest,
        IQueryResultSettings,
        // @ts-ignore -- Unused import
        NullResult
    } from '@msdyn365-commerce/retail-proxy';
    // @ts-ignore -- Unused import
    import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
    // @ts-ignore -- Unused import
    import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
    import * as DataServiceEntities from './DataServiceEntities.g';

    

        // @ts-ignore
        function k3InstructionIconTableQuery(recId?: number): DataServiceQuery {
        const key = (recId) ? { RecId: recId } :null;
        return new DataServiceQuery("K3InstructionIconTable", "K3InstructionIconTable", DataServiceEntities.K3InstructionIconTableExtensionClass, key);
        }

        
    export function createGetAllInstructionIconTableInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = k3InstructionIconTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetAllInstructionIconTable', true, DataServiceEntities.K3InstructionIconTableExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3InstructionIconTable'}, { });
    }

    
    export function getAllInstructionIconTableAsync(context: IContext): AsyncResult<DataServiceEntities.IK3InstructionIconTable[]> {
    const request = createGetAllInstructionIconTableInput(
      context.queryResultSettings || {}, );
    return callActionOrExecute<DataServiceEntities.IK3InstructionIconTable[]>(request, context.callerContext);
    }
  
    export function createGetInstructionIconTableByInstructionInput(queryResultSettings: IQueryResultSettings, instruction: number): IDataServiceRequest {
    const query = k3InstructionIconTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetInstructionIconTableByInstruction', true, DataServiceEntities.K3InstructionIconTableExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3InstructionIconTable'}, {instruction: instruction });
    }

    
    export function getInstructionIconTableByInstructionAsync(context: IContext, instruction: number): AsyncResult<DataServiceEntities.IK3InstructionIconTable[]> {
    const request = createGetInstructionIconTableByInstructionInput(
      context.queryResultSettings || {}, instruction);
    return callActionOrExecute<DataServiceEntities.IK3InstructionIconTable[]>(request, context.callerContext);
    }
  

        // @ts-ignore
        function k3InstructionTableQuery(recId?: number): DataServiceQuery {
        const key = (recId) ? { RecId: recId } :null;
        return new DataServiceQuery("K3InstructionTable", "K3InstructionTable", DataServiceEntities.K3InstructionTableExtensionClass, key);
        }

        
    export function createGetAllInstructionTableInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = k3InstructionTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetAllInstructionTable', true, DataServiceEntities.K3InstructionTableExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3InstructionTable'}, { });
    }

    
    export function getAllInstructionTableAsync(context: IContext): AsyncResult<DataServiceEntities.IK3InstructionTable[]> {
    const request = createGetAllInstructionTableInput(
      context.queryResultSettings || {}, );
    return callActionOrExecute<DataServiceEntities.IK3InstructionTable[]>(request, context.callerContext);
    }
  
    export function createGetInstructionTableByInstructionInput(queryResultSettings: IQueryResultSettings, instructionId: string): IDataServiceRequest {
    const query = k3InstructionTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetInstructionTableByInstruction', true, DataServiceEntities.K3InstructionTableExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3InstructionTable'}, {instructionId: instructionId });
    }

    
    export function getInstructionTableByInstructionAsync(context: IContext, instructionId: string): AsyncResult<DataServiceEntities.IK3InstructionTable[]> {
    const request = createGetInstructionTableByInstructionInput(
      context.queryResultSettings || {}, instructionId);
    return callActionOrExecute<DataServiceEntities.IK3InstructionTable[]>(request, context.callerContext);
    }
  

        // @ts-ignore
        function k3ProductWashCareTableQuery(recId?: number): DataServiceQuery {
        const key = (recId) ? { RecId: recId } :null;
        return new DataServiceQuery("K3ProductWashCareTable", "K3ProductWashCareTable", DataServiceEntities.K3ProductWashCareTableExtensionClass, key);
        }

        
    export function createGetAllWashCareTableInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = k3ProductWashCareTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetAllWashCareTable', true, DataServiceEntities.K3ProductWashCareTableExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3ProductWashCareTable'}, { });
    }

    
    export function getAllWashCareTableAsync(context: IContext): AsyncResult<DataServiceEntities.IK3ProductWashCareTable[]> {
    const request = createGetAllWashCareTableInput(
      context.queryResultSettings || {}, );
    return callActionOrExecute<DataServiceEntities.IK3ProductWashCareTable[]>(request, context.callerContext);
    }
  
    export function createGetProductWashCareByItemInput(queryResultSettings: IQueryResultSettings, itemId: string): IDataServiceRequest {
    const query = k3ProductWashCareTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetProductWashCareByItem', true, DataServiceEntities.K3ProductWashCareTableExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3ProductWashCareTable'}, {itemId: itemId });
    }

    
    export function getProductWashCareByItemAsync(context: IContext, itemId: string): AsyncResult<DataServiceEntities.IK3ProductWashCareTable[]> {
    const request = createGetProductWashCareByItemInput(
      context.queryResultSettings || {}, itemId);
    return callActionOrExecute<DataServiceEntities.IK3ProductWashCareTable[]>(request, context.callerContext);
    }
  
    export function createGetProductWashCareByProductInput(queryResultSettings: IQueryResultSettings, product: number): IDataServiceRequest {
    const query = k3ProductWashCareTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetProductWashCareByProduct', true, DataServiceEntities.K3ProductWashCareTableExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3ProductWashCareTable'}, {product: product });
    }

    
    export function getProductWashCareByProductAsync(context: IContext, product: number): AsyncResult<DataServiceEntities.IK3ProductWashCareTable[]> {
    const request = createGetProductWashCareByProductInput(
      context.queryResultSettings || {}, product);
    return callActionOrExecute<DataServiceEntities.IK3ProductWashCareTable[]>(request, context.callerContext);
    }
  

        // @ts-ignore
        function k3BrandTableQuery(recId?: number): DataServiceQuery {
        const key = (recId) ? { RecId: recId } :null;
        return new DataServiceQuery("K3BrandTable", "K3BrandTable", DataServiceEntities.K3BrandTableExtensionClass, key);
        }

        
    export function createGetAllK3BrandTableInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = k3BrandTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetAllK3BrandTable', true, DataServiceEntities.K3BrandTableExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3BrandTable'}, { });
    }

    
    export function getAllK3BrandTableAsync(context: IContext): AsyncResult<DataServiceEntities.IK3BrandTable[]> {
    const request = createGetAllK3BrandTableInput(
      context.queryResultSettings || {}, );
    return callActionOrExecute<DataServiceEntities.IK3BrandTable[]>(request, context.callerContext);
    }
  
    export function createGetK3BrandTableByBrandInput(queryResultSettings: IQueryResultSettings, brandId: string): IDataServiceRequest {
    const query = k3BrandTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetK3BrandTableByBrand', true, DataServiceEntities.K3BrandTableExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3BrandTable'}, {brandId: brandId });
    }

    
    export function getK3BrandTableByBrandAsync(context: IContext, brandId: string): AsyncResult<DataServiceEntities.IK3BrandTable[]> {
    const request = createGetK3BrandTableByBrandInput(
      context.queryResultSettings || {}, brandId);
    return callActionOrExecute<DataServiceEntities.IK3BrandTable[]>(request, context.callerContext);
    }
  

        // @ts-ignore
        function k3InventTableQuery(recId?: number): DataServiceQuery {
        const key = (recId) ? { RecId: recId } :null;
        return new DataServiceQuery("K3InventTable", "K3InventTable", DataServiceEntities.K3InventTableExtensionClass, key);
        }

        
    export function createGetAllK3InventTableInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = k3InventTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetAllK3InventTable', true, DataServiceEntities.K3InventTableExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3InventTable'}, { });
    }

    
    export function getAllK3InventTableAsync(context: IContext): AsyncResult<DataServiceEntities.IK3InventTable[]> {
    const request = createGetAllK3InventTableInput(
      context.queryResultSettings || {}, );
    return callActionOrExecute<DataServiceEntities.IK3InventTable[]>(request, context.callerContext);
    }
  
    export function createGetK3InventTableByProductInput(queryResultSettings: IQueryResultSettings, product: number): IDataServiceRequest {
    const query = k3InventTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetK3InventTableByProduct', true, DataServiceEntities.K3InventTableExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3InventTable'}, {product: product });
    }

    
    export function getK3InventTableByProductAsync(context: IContext, product: number): AsyncResult<DataServiceEntities.IK3InventTable[]> {
    const request = createGetK3InventTableByProductInput(
      context.queryResultSettings || {}, product);
    return callActionOrExecute<DataServiceEntities.IK3InventTable[]>(request, context.callerContext);
    }
  
    export function createGetK3InventTableByItemInput(queryResultSettings: IQueryResultSettings, itemId: string): IDataServiceRequest {
    const query = k3InventTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetK3InventTableByItem', true, DataServiceEntities.K3InventTableExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3InventTable'}, {itemId: itemId });
    }

    
    export function getK3InventTableByItemAsync(context: IContext, itemId: string): AsyncResult<DataServiceEntities.IK3InventTable[]> {
    const request = createGetK3InventTableByItemInput(
      context.queryResultSettings || {}, itemId);
    return callActionOrExecute<DataServiceEntities.IK3InventTable[]>(request, context.callerContext);
    }
  

        // @ts-ignore
        function k3POSParametersQuery(recId?: number): DataServiceQuery {
        const key = (recId) ? { RecId: recId } :null;
        return new DataServiceQuery("K3POSParameters", "K3POSParameters", DataServiceEntities.K3POSParametersExtensionClass, key);
        }

        
    export function createGetAllK3POSParametersInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = k3POSParametersQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetAllK3POSParameters', true, DataServiceEntities.K3POSParametersExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3POSParameters'}, { });
    }

    
    export function getAllK3POSParametersAsync(context: IContext): AsyncResult<DataServiceEntities.IK3POSParameters[]> {
    const request = createGetAllK3POSParametersInput(
      context.queryResultSettings || {}, );
    return callActionOrExecute<DataServiceEntities.IK3POSParameters[]>(request, context.callerContext);
    }
  

        // @ts-ignore
        function k3ItemMeasurementPhaseQuery(recId?: number): DataServiceQuery {
        const key = (recId) ? { RecId: recId } :null;
        return new DataServiceQuery("K3ItemMeasurementPhase", "K3ItemMeasurementPhase", DataServiceEntities.K3ItemMeasurementPhaseExtensionClass, key);
        }

        
    export function createGetAllItemMeasurementPhaseInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = k3ItemMeasurementPhaseQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetAllItemMeasurementPhase', true, DataServiceEntities.K3ItemMeasurementPhaseExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3ItemMeasurementPhase'}, { });
    }

    
    export function getAllItemMeasurementPhaseAsync(context: IContext): AsyncResult<DataServiceEntities.IK3ItemMeasurementPhase[]> {
    const request = createGetAllItemMeasurementPhaseInput(
      context.queryResultSettings || {}, );
    return callActionOrExecute<DataServiceEntities.IK3ItemMeasurementPhase[]>(request, context.callerContext);
    }
  
    export function createGetItemMeasurementPhaseByProductInput(queryResultSettings: IQueryResultSettings, product: number): IDataServiceRequest {
    const query = k3ItemMeasurementPhaseQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetItemMeasurementPhaseByProduct', true, DataServiceEntities.K3ItemMeasurementPhaseExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3ItemMeasurementPhase'}, {product: product });
    }

    
    export function getItemMeasurementPhaseByProductAsync(context: IContext, product: number): AsyncResult<DataServiceEntities.IK3ItemMeasurementPhase[]> {
    const request = createGetItemMeasurementPhaseByProductInput(
      context.queryResultSettings || {}, product);
    return callActionOrExecute<DataServiceEntities.IK3ItemMeasurementPhase[]>(request, context.callerContext);
    }
  

        // @ts-ignore
        function k3ItemMeasurementPositionsQuery(recId?: number): DataServiceQuery {
        const key = (recId) ? { RecId: recId } :null;
        return new DataServiceQuery("K3ItemMeasurementPositions", "K3ItemMeasurementPositions", DataServiceEntities.K3ItemMeasurementPositionsExtensionClass, key);
        }

        
    export function createGetAllItemMeasurementPositionsInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = k3ItemMeasurementPositionsQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetAllItemMeasurementPositions', true, DataServiceEntities.K3ItemMeasurementPositionsExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3ItemMeasurementPositions'}, { });
    }

    
    export function getAllItemMeasurementPositionsAsync(context: IContext): AsyncResult<DataServiceEntities.IK3ItemMeasurementPositions[]> {
    const request = createGetAllItemMeasurementPositionsInput(
      context.queryResultSettings || {}, );
    return callActionOrExecute<DataServiceEntities.IK3ItemMeasurementPositions[]>(request, context.callerContext);
    }
  
    export function createGetItemMeasurementPositionsByProductInput(queryResultSettings: IQueryResultSettings, product: number): IDataServiceRequest {
    const query = k3ItemMeasurementPositionsQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetItemMeasurementPositionsByProduct', true, DataServiceEntities.K3ItemMeasurementPositionsExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3ItemMeasurementPositions'}, {product: product });
    }

    
    export function getItemMeasurementPositionsByProductAsync(context: IContext, product: number): AsyncResult<DataServiceEntities.IK3ItemMeasurementPositions[]> {
    const request = createGetItemMeasurementPositionsByProductInput(
      context.queryResultSettings || {}, product);
    return callActionOrExecute<DataServiceEntities.IK3ItemMeasurementPositions[]>(request, context.callerContext);
    }
  

        // @ts-ignore
        function k3ItemMeasurementPositionsTranslationQuery(recId?: number): DataServiceQuery {
        const key = (recId) ? { RecId: recId } :null;
        return new DataServiceQuery("K3ItemMeasurementPositionsTranslation", "K3ItemMeasurementPositionsTranslation", DataServiceEntities.K3ItemMeasurementPositionsTranslationExtensionClass, key);
        }

        
    export function createGetAllItemMeasurementPositionsTranslationInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = k3ItemMeasurementPositionsTranslationQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetAllItemMeasurementPositionsTranslation', true, DataServiceEntities.K3ItemMeasurementPositionsTranslationExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3ItemMeasurementPositionsTranslation'}, { });
    }

    
    export function getAllItemMeasurementPositionsTranslationAsync(context: IContext): AsyncResult<DataServiceEntities.IK3ItemMeasurementPositionsTranslation[]> {
    const request = createGetAllItemMeasurementPositionsTranslationInput(
      context.queryResultSettings || {}, );
    return callActionOrExecute<DataServiceEntities.IK3ItemMeasurementPositionsTranslation[]>(request, context.callerContext);
    }
  

        // @ts-ignore
        function k3ItemMeasurementSizeDisplayOrderQuery(recId?: number): DataServiceQuery {
        const key = (recId) ? { RecId: recId } :null;
        return new DataServiceQuery("K3ItemMeasurementSizeDisplayOrder", "K3ItemMeasurementSizeDisplayOrder", DataServiceEntities.K3ItemMeasurementSizeDisplayOrderExtensionClass, key);
        }

        
    export function createGetAllItemMeasurementSizeDisplayOrderInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = k3ItemMeasurementSizeDisplayOrderQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetAllItemMeasurementSizeDisplayOrder', true, DataServiceEntities.K3ItemMeasurementSizeDisplayOrderExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3ItemMeasurementSizeDisplayOrder'}, { });
    }

    
    export function getAllItemMeasurementSizeDisplayOrderAsync(context: IContext): AsyncResult<DataServiceEntities.IK3ItemMeasurementSizeDisplayOrder[]> {
    const request = createGetAllItemMeasurementSizeDisplayOrderInput(
      context.queryResultSettings || {}, );
    return callActionOrExecute<DataServiceEntities.IK3ItemMeasurementSizeDisplayOrder[]>(request, context.callerContext);
    }
  
    export function createGetItemMeasurementSizeDisplayOrderByProductInput(queryResultSettings: IQueryResultSettings, product: number): IDataServiceRequest {
    const query = k3ItemMeasurementSizeDisplayOrderQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetItemMeasurementSizeDisplayOrderByProduct', true, DataServiceEntities.K3ItemMeasurementSizeDisplayOrderExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3ItemMeasurementSizeDisplayOrder'}, {product: product });
    }

    
    export function getItemMeasurementSizeDisplayOrderByProductAsync(context: IContext, product: number): AsyncResult<DataServiceEntities.IK3ItemMeasurementSizeDisplayOrder[]> {
    const request = createGetItemMeasurementSizeDisplayOrderByProductInput(
      context.queryResultSettings || {}, product);
    return callActionOrExecute<DataServiceEntities.IK3ItemMeasurementSizeDisplayOrder[]>(request, context.callerContext);
    }
  

        // @ts-ignore
        function k3ItemMeasurementTableQuery(recId?: number): DataServiceQuery {
        const key = (recId) ? { RecId: recId } :null;
        return new DataServiceQuery("K3ItemMeasurementTable", "K3ItemMeasurementTable", DataServiceEntities.K3ItemMeasurementTableExtensionClass, key);
        }

        
    export function createGetAllItemMeasurementTableInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = k3ItemMeasurementTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetAllItemMeasurementTable', true, DataServiceEntities.K3ItemMeasurementTableExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3ItemMeasurementTable'}, { });
    }

    
    export function getAllItemMeasurementTableAsync(context: IContext): AsyncResult<DataServiceEntities.IK3ItemMeasurementTable[]> {
    const request = createGetAllItemMeasurementTableInput(
      context.queryResultSettings || {}, );
    return callActionOrExecute<DataServiceEntities.IK3ItemMeasurementTable[]>(request, context.callerContext);
    }
  
    export function createGetItemMeasurementTableByProductInput(queryResultSettings: IQueryResultSettings, product: number): IDataServiceRequest {
    const query = k3ItemMeasurementTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetItemMeasurementTableByProduct', true, DataServiceEntities.K3ItemMeasurementTableExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3ItemMeasurementTable'}, {product: product });
    }

    
    export function getItemMeasurementTableByProductAsync(context: IContext, product: number): AsyncResult<DataServiceEntities.IK3ItemMeasurementTable[]> {
    const request = createGetItemMeasurementTableByProductInput(
      context.queryResultSettings || {}, product);
    return callActionOrExecute<DataServiceEntities.IK3ItemMeasurementTable[]>(request, context.callerContext);
    }
  

        // @ts-ignore
        function k3ItemMeasurementUnitMeasureQuery(recId?: number): DataServiceQuery {
        const key = (recId) ? { RecId: recId } :null;
        return new DataServiceQuery("K3ItemMeasurementUnitMeasure", "K3ItemMeasurementUnitMeasure", DataServiceEntities.K3ItemMeasurementUnitMeasureExtensionClass, key);
        }

        
    export function createGetAllItemMeasurementUnitMeasureInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = k3ItemMeasurementUnitMeasureQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetAllItemMeasurementUnitMeasure', true, DataServiceEntities.K3ItemMeasurementUnitMeasureExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3ItemMeasurementUnitMeasure'}, { });
    }

    
    export function getAllItemMeasurementUnitMeasureAsync(context: IContext): AsyncResult<DataServiceEntities.IK3ItemMeasurementUnitMeasure[]> {
    const request = createGetAllItemMeasurementUnitMeasureInput(
      context.queryResultSettings || {}, );
    return callActionOrExecute<DataServiceEntities.IK3ItemMeasurementUnitMeasure[]>(request, context.callerContext);
    }
  
    export function createGetItemMeasurementUnitMeasureByProductInput(queryResultSettings: IQueryResultSettings, product: number): IDataServiceRequest {
    const query = k3ItemMeasurementUnitMeasureQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetItemMeasurementUnitMeasureByProduct', true, DataServiceEntities.K3ItemMeasurementUnitMeasureExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3ItemMeasurementUnitMeasure'}, {product: product });
    }

    
    export function getItemMeasurementUnitMeasureByProductAsync(context: IContext, product: number): AsyncResult<DataServiceEntities.IK3ItemMeasurementUnitMeasure[]> {
    const request = createGetItemMeasurementUnitMeasureByProductInput(
      context.queryResultSettings || {}, product);
    return callActionOrExecute<DataServiceEntities.IK3ItemMeasurementUnitMeasure[]>(request, context.callerContext);
    }
  

        // @ts-ignore
        function k3PhaseTableQuery(recId?: number): DataServiceQuery {
        const key = (recId) ? { RecId: recId } :null;
        return new DataServiceQuery("K3PhaseTable", "K3PhaseTable", DataServiceEntities.K3PhaseTableExtensionClass, key);
        }

        
    export function createGetAllPhaseTableInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = k3PhaseTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetAllPhaseTable', true, DataServiceEntities.K3PhaseTableExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3PhaseTable'}, { });
    }

    
    export function getAllPhaseTableAsync(context: IContext): AsyncResult<DataServiceEntities.IK3PhaseTable[]> {
    const request = createGetAllPhaseTableInput(
      context.queryResultSettings || {}, );
    return callActionOrExecute<DataServiceEntities.IK3PhaseTable[]>(request, context.callerContext);
    }
  

        // @ts-ignore
        function k3PhaseTranslationQuery(recId?: number): DataServiceQuery {
        const key = (recId) ? { RecId: recId } :null;
        return new DataServiceQuery("K3PhaseTranslation", "K3PhaseTranslation", DataServiceEntities.K3PhaseTranslationExtensionClass, key);
        }

        
    export function createGetAllPhaseTranslationInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = k3PhaseTranslationQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetAllPhaseTranslation', true, DataServiceEntities.K3PhaseTranslationExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3PhaseTranslation'}, { });
    }

    
    export function getAllPhaseTranslationAsync(context: IContext): AsyncResult<DataServiceEntities.IK3PhaseTranslation[]> {
    const request = createGetAllPhaseTranslationInput(
      context.queryResultSettings || {}, );
    return callActionOrExecute<DataServiceEntities.IK3PhaseTranslation[]>(request, context.callerContext);
    }
  

        // @ts-ignore
        function k3CSRClassificationIconTableQuery(recId?: number): DataServiceQuery {
        const key = (recId) ? { RecId: recId } :null;
        return new DataServiceQuery("K3CSRClassificationIconTable", "K3CSRClassificationIconTable", DataServiceEntities.K3CSRClassificationIconTableExtensionClass, key);
        }

        
    export function createGetAllCSRClassificationIconTableInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = k3CSRClassificationIconTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetAllCSRClassificationIconTable', true, DataServiceEntities.K3CSRClassificationIconTableExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3CSRClassificationIconTable'}, { });
    }

    
    export function getAllCSRClassificationIconTableAsync(context: IContext): AsyncResult<DataServiceEntities.IK3CSRClassificationIconTable[]> {
    const request = createGetAllCSRClassificationIconTableInput(
      context.queryResultSettings || {}, );
    return callActionOrExecute<DataServiceEntities.IK3CSRClassificationIconTable[]>(request, context.callerContext);
    }
  

        // @ts-ignore
        function k3CSRClassificationTableQuery(recId?: number): DataServiceQuery {
        const key = (recId) ? { RecId: recId } :null;
        return new DataServiceQuery("K3CSRClassificationTable", "K3CSRClassificationTable", DataServiceEntities.K3CSRClassificationTableExtensionClass, key);
        }

        
    export function createGetAllCSRClassificationTableInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = k3CSRClassificationTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetAllCSRClassificationTable', true, DataServiceEntities.K3CSRClassificationTableExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3CSRClassificationTable'}, { });
    }

    
    export function getAllCSRClassificationTableAsync(context: IContext): AsyncResult<DataServiceEntities.IK3CSRClassificationTable[]> {
    const request = createGetAllCSRClassificationTableInput(
      context.queryResultSettings || {}, );
    return callActionOrExecute<DataServiceEntities.IK3CSRClassificationTable[]>(request, context.callerContext);
    }
  

        // @ts-ignore
        function k3CSRClassificationTranslationTableQuery(recId?: number): DataServiceQuery {
        const key = (recId) ? { RecId: recId } :null;
        return new DataServiceQuery("K3CSRClassificationTranslationTable", "K3CSRClassificationTranslationTable", DataServiceEntities.K3CSRClassificationTranslationTableExtensionClass, key);
        }

        
    export function createGetAllCSRClassificationTranslationTableInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = k3CSRClassificationTranslationTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetAllCSRClassificationTranslationTable', true, DataServiceEntities.K3CSRClassificationTranslationTableExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3CSRClassificationTranslationTable'}, { });
    }

    
    export function getAllCSRClassificationTranslationTableAsync(context: IContext): AsyncResult<DataServiceEntities.IK3CSRClassificationTranslationTable[]> {
    const request = createGetAllCSRClassificationTranslationTableInput(
      context.queryResultSettings || {}, );
    return callActionOrExecute<DataServiceEntities.IK3CSRClassificationTranslationTable[]>(request, context.callerContext);
    }
  

        // @ts-ignore
        function k3ProductCSRClassificationsTableQuery(recId?: number): DataServiceQuery {
        const key = (recId) ? { RecId: recId } :null;
        return new DataServiceQuery("K3ProductCSRClassificationsTable", "K3ProductCSRClassificationsTable", DataServiceEntities.K3ProductCSRClassificationsTableExtensionClass, key);
        }

        
    export function createGetAllProductCSRClassificationTableInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = k3ProductCSRClassificationsTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetAllProductCSRClassificationTable', true, DataServiceEntities.K3ProductCSRClassificationsTableExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3ProductCSRClassificationsTable'}, { });
    }

    
    export function getAllProductCSRClassificationTableAsync(context: IContext): AsyncResult<DataServiceEntities.IK3ProductCSRClassificationsTable[]> {
    const request = createGetAllProductCSRClassificationTableInput(
      context.queryResultSettings || {}, );
    return callActionOrExecute<DataServiceEntities.IK3ProductCSRClassificationsTable[]>(request, context.callerContext);
    }
  
    export function createGetProductCSRClassificationTableByProductInput(queryResultSettings: IQueryResultSettings, product: number): IDataServiceRequest {
    const query = k3ProductCSRClassificationsTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetProductCSRClassificationTableByProduct', true, DataServiceEntities.K3ProductCSRClassificationsTableExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3ProductCSRClassificationsTable'}, {product: product });
    }

    
    export function getProductCSRClassificationTableByProductAsync(context: IContext, product: number): AsyncResult<DataServiceEntities.IK3ProductCSRClassificationsTable[]> {
    const request = createGetProductCSRClassificationTableByProductInput(
      context.queryResultSettings || {}, product);
    return callActionOrExecute<DataServiceEntities.IK3ProductCSRClassificationsTable[]>(request, context.callerContext);
    }
  

        // @ts-ignore
        function k3CompositionTypeTableQuery(recId?: number): DataServiceQuery {
        const key = (recId) ? { RecId: recId } :null;
        return new DataServiceQuery("K3CompositionTypeTable", "K3CompositionTypeTable", DataServiceEntities.K3CompositionTypeTableExtensionClass, key);
        }

        
    export function createGetAllCompositionTypeTableInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = k3CompositionTypeTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetAllCompositionTypeTable', true, DataServiceEntities.K3CompositionTypeTableExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3CompositionTypeTable'}, { });
    }

    
    export function getAllCompositionTypeTableAsync(context: IContext): AsyncResult<DataServiceEntities.IK3CompositionTypeTable[]> {
    const request = createGetAllCompositionTypeTableInput(
      context.queryResultSettings || {}, );
    return callActionOrExecute<DataServiceEntities.IK3CompositionTypeTable[]>(request, context.callerContext);
    }
  

        // @ts-ignore
        function k3FibreTableQuery(recId?: number): DataServiceQuery {
        const key = (recId) ? { RecId: recId } :null;
        return new DataServiceQuery("K3FibreTable", "K3FibreTable", DataServiceEntities.K3FibreTableExtensionClass, key);
        }

        
    export function createGetAllFibreTableInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = k3FibreTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetAllFibreTable', true, DataServiceEntities.K3FibreTableExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3FibreTable'}, { });
    }

    
    export function getAllFibreTableAsync(context: IContext): AsyncResult<DataServiceEntities.IK3FibreTable[]> {
    const request = createGetAllFibreTableInput(
      context.queryResultSettings || {}, );
    return callActionOrExecute<DataServiceEntities.IK3FibreTable[]>(request, context.callerContext);
    }
  

        // @ts-ignore
        function k3FibreTranslationTableQuery(recId?: number): DataServiceQuery {
        const key = (recId) ? { RecId: recId } :null;
        return new DataServiceQuery("K3FibreTranslationTable", "K3FibreTranslationTable", DataServiceEntities.K3FibreTranslationTableExtensionClass, key);
        }

        
    export function createGetAllFibreTranslationTableInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = k3FibreTranslationTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetAllFibreTranslationTable', true, DataServiceEntities.K3FibreTranslationTableExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3FibreTranslationTable'}, { });
    }

    
    export function getAllFibreTranslationTableAsync(context: IContext): AsyncResult<DataServiceEntities.IK3FibreTranslationTable[]> {
    const request = createGetAllFibreTranslationTableInput(
      context.queryResultSettings || {}, );
    return callActionOrExecute<DataServiceEntities.IK3FibreTranslationTable[]>(request, context.callerContext);
    }
  

        // @ts-ignore
        function k3ProductCompositionTableQuery(recId?: number): DataServiceQuery {
        const key = (recId) ? { RecId: recId } :null;
        return new DataServiceQuery("K3ProductCompositionTable", "K3ProductCompositionTable", DataServiceEntities.K3ProductCompositionTableExtensionClass, key);
        }

        
    export function createGetAllProductCompositionTableInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = k3ProductCompositionTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetAllProductCompositionTable', true, DataServiceEntities.K3ProductCompositionTableExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3ProductCompositionTable'}, { });
    }

    
    export function getAllProductCompositionTableAsync(context: IContext): AsyncResult<DataServiceEntities.IK3ProductCompositionTable[]> {
    const request = createGetAllProductCompositionTableInput(
      context.queryResultSettings || {}, );
    return callActionOrExecute<DataServiceEntities.IK3ProductCompositionTable[]>(request, context.callerContext);
    }
  
    export function createGetProductCompositionTableByProductInput(queryResultSettings: IQueryResultSettings, product: number): IDataServiceRequest {
    const query = k3ProductCompositionTableQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetProductCompositionTableByProduct', true, DataServiceEntities.K3ProductCompositionTableExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IK3ProductCompositionTable'}, {product: product });
    }

    
    export function getProductCompositionTableByProductAsync(context: IContext, product: number): AsyncResult<DataServiceEntities.IK3ProductCompositionTable[]> {
    const request = createGetProductCompositionTableByProductInput(
      context.queryResultSettings || {}, product);
    return callActionOrExecute<DataServiceEntities.IK3ProductCompositionTable[]>(request, context.callerContext);
    }
  